<template lang="html">
    <div class="common-select common-select-multiple">
        <input type="hidden" v-bind:value="innerValue" />
        <div class="common-select-title"><span @click="handleSelectClick">{{title}}</span><common-tooltip v-if="!!tipCode" :tipCode="tipCode"></common-tooltip><span class="not-required" :class="required?'required':''">*</span></div>
        <div :class="['common-select-infos',alignRight?'common-select-infos-align-right':'common-select-infos-align-left']" @click="handleSelectClick">
            <div :class="['common-select-text',title?'':'no-title']">{{currentText}}</div>
            <div class="common-select-placeholder" v-show="!currentText">{{placeholder}}</div>
            <div class="common-select-dropdown-icon" :class="'common-select-dropdown-icon-'+iconType"></div>
        </div>
        <mt-popup
            v-model="popupVisible"
            position="bottom"
            class="common-select-options">
            <div>
                <div class="common-select-options-toolbar">
                    <mt-button v-if="clearable && innerValue && innerValue.length > 0" @click="handleCancleClick" type="default" size="small" class="common-select-options-toolbar-cancel-btn cancel-btn">清除</mt-button>
                    <input v-if="filterable" class="search-input" type="search" :placeholder="'输入搜索内容'" v-model="searchText" />
                    <mt-button @click="handleComfirmClick" type="primary" size="small" class="common-select-options-toolbar-confirm-btn">确定</mt-button>
                </div>
                <div>
                    <mt-checklist
                        class="items"
                        title=""
                        v-model="selectObj"
                        :options="checkListDatas">
                    </mt-checklist>
                </div>
            </div>
        </mt-popup>
    </div>
</template>

<script>
import { Popup, Checklist  } from 'mint-ui';
  export default {
    props: {
        'title': {
            type: String,
            required: false
        },
        'placeholder': {
            type: String,
            required: false
        },
        'value': {

        },
        'datas': {
            required: true
        },
        'valueKey': {
            type:String,
            required: true
        },
        'textKey': {
            type:String,
            required: true
        },
        'alignRight': {
            type:Boolean,
            required: false,
            default:false,
        },
        'clearable': {
            type:Boolean,
            required: false,
            default:false,
        },
        'includeDatas': {
            type:Array,
            required: false,
        },
        'required': {
            type:Boolean,
            required: false,
            default: false,
        },
        'handleItem': {
            type:Function,
            required: false,
        },
        'tipCode': {
            required: false
        },
        'iconType': {
            type: String,
            required: false,
            default:'arrow'
        },
        'filterable': {
            type:Boolean,
            required: false,
            default: false,
        },
    },
    event: 'change',
    components: {
        Popup,
        Checklist ,
    },
    data() {
        return {
            popupVisible: false,
            selectObj: [],
            checkListDatas: [],
            currentText: '',
            innerData: [],
            searchText: '',
            allDatas: []
        };
    },
    computed: {
        selectedText() {
            let text = [];

            this.selectObj.forEach(res => {
                this.innerData.forEach(el => {
                    if(res == el[this.valueKey]){
                        text.push(el[this.textKey]);
                    }
                })
            })

            return text.join('、')
        },
        innerValue: {
            get() {
               return this.value 
            },
            set(val) {
                 this.$emit('input', val) //这里多用于子组件间没有input元素中,通过在computed属性中监听值变化事emit input事件
            }
        }
    },
    methods: {
        handleSelectClick() {
            this.searchText = ''
            this.popupVisible = true;
        },
        handleCancleClick() {
            this.currentText = '';
            this.innerValue = [];
            this.selectObj = []
            this.popupVisible = false;

            this.$emit('change');
        },
        handleComfirmClick() {
            this.currentText = this.selectedText;
            this.innerValue = this.selectObj;
            this.popupVisible = false;

            this.$emit('change');
        },
        initCheckListDatas(query) {   
            let data = this.allDatas;         
            if(data){
                this.checkListDatas = []
                let tempDatas = data.concat((this.includeDatas?this.includeDatas:[]));
                tempDatas.forEach(el => {
                    if(query) {
                        if(!el[this.textKey] || !el[this.valueKey]) {
                            return;
                        }

                        if(el[this.textKey].toLowerCase().indexOf(query.toLowerCase()) < 0 && el[this.valueKey].toLowerCase().indexOf(query.toLowerCase()) < 0) {
                            return;
                        }
                    }
                    let item = {
                        label: el[this.textKey],
                        value: el[this.valueKey]
                    };
                    if(this.handleItem) {
                        this.handleItem(item);
                    }
                    this.checkListDatas.push(item)
                })

                this.innerData = tempDatas;
            }
        },
        setDatas(data) {
            this.allDatas = data;
            this.initCheckListDatas();
        }
    },
    watch: {
        datas() {
            this.allDatas = this.datas;
            this.initCheckListDatas();
        },
        value() {
            this.selectObj = this.value;
            this.innerValue = this.selectObj;
            this.currentText = this.selectedText;
        },
        searchText() {
            this.initCheckListDatas(this.searchText);
        }
    },
    mounted: function() {
        this.allDatas = this.datas;
        this.initCheckListDatas()
    }
  };
</script>

<style lang="less" scoped>
    .common-select {
        display: flex;
        min-height: 24px;
        font-size: 14px;

        &-title {
            line-height: 24px;
        }

        &-dropdown-icon-trigle {
            width: 0;
            height: 0;
            border-left: 6px solid transparent; //左边宽度50px，实线，透明颜色
            border-right: 6px solid transparent; //右边同上
            border-top: 6px solid #999999;
            margin-top: 9px;
            margin-left: 7px;
        }

        &-dropdown-icon-arrow {
            width: 9px;
            height: 9px;
            margin-top: 7px;
            border-top: 1px solid #999999;
            border-right: 1px solid #999999;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            margin-left: 4px;
        }

        &-text {
            min-height: 24px;
            line-height: 24px;
            max-width: 200px;
        }

        &-text.no-title {
            max-width: 330px;
        }

        &-infos {
            display: flex;

            &-align-right {
                    margin-left: auto;
                    padding-right: 20px;
            }

            &-align-left {
                width: 100%;
                position: relative;

                .common-select-dropdown-icon {
                    position: absolute;
                    right: 20px;
                }
            }
        }

        &-placeholder {
            color: #999999;
            line-height: 24px;
        }

        &-options {
            &-toolbar {
                padding: 10px 15px 0 15px;

                &-selected-info {
                    height: 32px;
                    line-height: 32px;
                    margin-left: 10px;
                }

                &-cancel-btn {
                    float: left;
                }

                &-confirm-btn {
                    float: right;
                }

                .search-input {
                    height: 35px;
                    width: 220px;
                    position: absolute;
                    right: 80px;
                    border: 1px solid #dfdfdf;
                    padding: 0 10px;
                    border-radius: 4px;
                }
            }
        }       

        .not-required {
            display: none;
        }
        
        .required {
            display: inline;
            color: #E64100;
            margin-left: 5px;
        }
    }
</style>


// WEBPACK FOOTER //
// CommonSelectMultiple.vue?258c4c56